import { Component, ElementRef, ViewChild } from '@angular/core';
import { TrackingFacadeService } from 'src/app/services/tracking/tracking-facade.service';
import { ViewportService } from 'src/app/services/viewport.service';
import { ModalComponent } from '../modal.component/modal.component';

@Component({
  selector: 'app-product-change-modal',
  templateUrl: './product-change-modal.component.html',
  styleUrls: ['./product-change-modal.component.scss'],
})
export class ProductChangeModalComponent {
  
  @ViewChild('modal') public modal: ModalComponent;

  @ViewChild('top') public top: ElementRef;
  
  private trackingFacadeService: TrackingFacadeService
  private readonly viewportService: ViewportService;

  public constructor(
      trackingFacadeService: TrackingFacadeService,
      viewportService: ViewportService) 
      {
        this.trackingFacadeService = trackingFacadeService;
        this.viewportService = viewportService;
      }

  public open() {
    // Leave this for when tracking params are decided.
    // const path = window.location.href;
    // this.trackingFacadeService.virtualPageView(path, 'Sådan fungerer det modal');
    this.modal.open();
  }
  
  public closeModal() {
    this.modal.close();
  }

  public scrollToNumberInput(): void
  {
      setTimeout(() => { this.viewportService.scrollIntoView(this.top.nativeElement, 0); }, 200);
  }
}
